import {
    useAllAvailableOperatorsQuery,
} from "../../services/endpoints/user.api";

import "./availableOperators.css"
const AvailableOperatorsWidget = () => {
    const { data, isLoading, isError } = useAllAvailableOperatorsQuery(undefined,{
        pollingInterval: 10000, // ogni 60.000 ms = 1 minuto
        skip: false, // ogni 60.000 ms = 1 minuto
    });
    console.log(data)
    const count = data?.data.length || 0;

    return (
        <div
            className="position-fixed bottom-0 start-0 m-3 p-3 bg-info border rounded shadow"
            style={{ zIndex: 1050, minWidth: '220px' }}
        >
            <h6 className="mb-1">Operatori Disponibili</h6>
            {isLoading ? (
                <div className="text-muted">Caricamento...</div>
            ) : isError ? (
                <div className="text-danger">Errore nel caricamento</div>
            ) : count > 0 ? (
                <div className="d-flex align-items-center gap-2">
                    <span className="blinking-dot bg-success"></span>
                    <span className="text-success">{count} Online</span>
                </div>            ) : (
                <span className="text-danger">Nessun operatore disponibile</span>
            )}
        </div>
    );
};

export default AvailableOperatorsWidget;
